import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    textTransform: 'uppercase',
  },
}))

export default useStyles
